import {
    CheckOutlined,
    CloseOutlined,
    SearchOutlined
} from '@ant-design/icons';
import { KPIPhongBanPagingResponse } from '@app/models/kpi/KPIPhongBan';
import { Button, Col, DatePicker, DatePickerProps, Input, Row, Space, Tabs } from 'antd';
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip } from 'chart.js';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idQuyDauTu, maChucVu, trangThaiKPI, trangThaiKPITongHop } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon } from '../../helpers/common';
import { KPIDuyetResponse } from '../../models/kpi/KPICaNhan';
import { KPIThang } from '../../models/kpi/KPIPhongBan';
import ContainerDonViPhuTrach from '../../modules/department/ContainerDonViPhuTrach';
import { layTongHopKPIThang, pheDuyetKPICaNhan, pheDuyetTongHopKPI, timKiemDSKPIDuyet } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import DuyetKPIGiamDocTable from './DuyetKPIGiamDocTable';
import ModalTongHopLoiViPham from './ModalTongHopLoiViPham';
import TabKetQuaHoanThanh from './TabKetQuaHoanThanh';
import YKienVanPhong from './components/YKienVanPhong';
import QuanLyTieuDeKPI from './QuanLyTieuDeKPI';
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
const DuyetKPIGiamDoc = () => {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState<string>("1");
    const menu: any = menuHelper.checkMultiPermission([Links.KPI.LanhDaoDonViDuyet]);
    const [openModalChiTiet, setOpenModalChiTiet] = useState<any>({});
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [openModalLoiViPham, setOpenModalLoiViPham] = useState<boolean>(false);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [idDonVi, setIdDonVi] = useState<number>(idQuyDauTu);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [tuKhoaCV, setTuKhoaCV] = useState<string>("");
    const [idDonViCV, setIdDonViCV] = useState<number>(idQuyDauTu);
    let ngayHienTai = (dayjs()).date() <= 10 ? (dayjs()).subtract(1, 'month') : dayjs();
    let thangHienTai = ngayHienTai.startOf('month').format('DD/MM/YYYY HH:mm:ss');
    const [thangNam, setThangNam] = useState<string>(thangHienTai);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(ngayHienTai);
    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedRows, setSelectedRows] = useState<Array<KPIDuyetResponse>>([]);
    const [data, setData] = useState<Array<KPIDuyetResponse>>([]);
    const [danhsach, setDanhSach] = useState<KPIPhongBanPagingResponse>({
        "data": [],
        "nhanViens": []
    });
    const [tongHopKPI, setTongHopKPI] = useState<KPIThang | null>(null);
    const user = useSelector((state: any) => state.auth.currentUser);
    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            setThangNam(dateStr);
            timkiem(idDonVi, tuKhoa, dateStr);
            layThongTinKPIThang(date?.startOf('month').format('MM/YYYY') || "");
        } else {
            setThangNam("");
            timkiem(idDonVi, tuKhoa, "");
            setTongHopKPI(null);
        }
    }

    const layThongTinKPIThang = async (thangNam: string) => {
        dispatch(showLoadingScreen());
        var rs = await layTongHopKPIThang(thangNam);

        setTongHopKPI(rs);
        dispatch(hideLoadingScreen());
    }

    const onChangeDepartment = (e: any) => {
        if (e) {
            setIdDonVi(e.id);
            timkiem(e.id, tuKhoa, thangNam);
        } else {
            setIdDonVi(0);
            setData([]);
            setDanhSach({
                "data": [],
                "nhanViens": []
            });
        }
    };

    const containerDepartmentProps = {
        showHeader: false,
        onChange: onChangeDepartment,
        value: idDonVi
    }

    const timkiem = async (idDonVi: number, tuKhoa: string, thangNam: string) => {
        try {
            setIsLoadingTable(true);
            const temp = await timKiemDSKPIDuyet(idDonVi, tuKhoa, thangNam);
            setData((temp?.data || []).map((item: any) => {
                return { ...item, key: item.idKPICaNhan }
            }));
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => {
                    return { ...item, key: item.idKPICaNhan }
                }),
                "nhanViens": (temp?.nhanViens || []).map((item: any) => {
                    return { ...item, key: item.idNhanVien }
                })
            });
            if (openModalChiTiet?.isShowModal) {
                setOpenModalChiTiet(prev => ({
                    ...prev,
                    data: prev.data.map(item => {
                        const rawNewItem = temp?.data?.find(x => x.idKPICaNhan === item.idKPICaNhan);
                        const newItem = rawNewItem ? { ...rawNewItem, key: rawNewItem.idKPICaNhan } : undefined;
                        const isApproved = item.trangThai === trangThaiKPI.pheDuyet;
                        const updatedItem = newItem ?? { ...item, trangThai: trangThaiKPI.pheDuyet };
                        if (isApproved || updatedItem.trangThai === trangThaiKPI.pheDuyet) {
                            return { ...updatedItem, trangThai: trangThaiKPI.pheDuyet };
                        }
                        return updatedItem;
                    }),
                }));
            }
            setIsLoadingTable(false);
        }
        catch (error: any) {
            setIsLoadingTable(false);
        };
    }
    const eventDuyetToanDonVi = async () => {
        const validRows = danhsach.data.filter((record: KPIDuyetResponse) =>
            record.trangThai == trangThaiKPI.trinhLanhDaoDonVi ||
            (record.trangThai == trangThaiKPI.khoiTao && record.idNhanVien == user.idNhanVien)
        );

        if (validRows.length > 0) {
            setSelectedRows(validRows);
            setSelectedRowKeys(validRows.map(r => r.idKPICaNhan));

            setOpenModalChiTiet({
                isShowModal: true,
                data: validRows,
                tenDonVi: "",
                isDuyet: true,
                onSubmit: () => duyetKPICaNhan(validRows)
            });
        } else {
            toast.error("Không có KPI nào chờ duyệt");
        }
    }


    const eventDuyetKPICaNhan = async () => {
        if (selectedRows.length > 0) {
            setConfirmModal({
                isShowModal: true,
                title: "Duyệt KPI toàn đơn vị",
                content:
                    <>Bạn có muốn <label>Duyệt</label> {selectedRows.length} bảng đánh giá KPI này không?</>,
                onSubmit: () => duyetKPICaNhan()
            });
        } else {
            const validRows = data.filter((record: KPIDuyetResponse) =>
                record.trangThai == trangThaiKPI.trinhLanhDaoDonVi ||
                (record.trangThai == trangThaiKPI.khoiTao && record.idNhanVien == user.idNhanVien)
            );

            if (validRows.length > 0) {
                setSelectedRows(validRows);
                setSelectedRowKeys(validRows.map(r => r.idKPICaNhan));

                setConfirmModal({
                    isShowModal: true,
                    title: "Duyệt KPI toàn đơn vị",
                    content:
                        <>Bạn có muốn <label>Duyệt</label> {validRows.length} bảng đánh giá KPI này không?</>,
                    onSubmit: () => duyetKPICaNhan(validRows)
                });
            } else {
                toast.error("Không có KPI nào chờ duyệt");
            }
        }
    }

    const eventTraLaiTongHopKPI = async () => {
        dispatch(showLoadingScreen());
        try {
            var rs = await pheDuyetTongHopKPI({
                id: tongHopKPI?.id || 0,
                isDuyet: false
            });
            toast.success("Trả lại tổng hợp KPI thành công");
            setTongHopKPI(rs);
        } catch (e: any) {
            toast.error("Trả lại tổng hợp KPI không thành công");
        }

        dispatch(hideLoadingScreen());
    }

    const duyetKPICaNhan = async (rowsToApprove?: any) => {
        dispatch(showLoadingScreen());
        try {
            const listDuyet = (rowsToApprove && rowsToApprove.length > 0) ? rowsToApprove : selectedRows;
            var request = {
                isDuyet: true,
                lyDo: "",
                danhSachDuyet: listDuyet
            };
            await pheDuyetKPICaNhan(request);
            toast.success("Duyệt KPI thành công");
            if (openModalChiTiet && typeof openModalChiTiet === 'object' && openModalChiTiet.data) {
                const approvedIds = new Set(listDuyet.map((r: any) => r.idKPICaNhan));
                setOpenModalChiTiet((prev: any) => ({
                    ...prev,
                    data: prev.data?.map((item: any) => {
                        if (approvedIds.has(item.idKPICaNhan)) {
                            return { ...item, trangThai: trangThaiKPI.pheDuyet };
                        }
                        return item;
                    })
                }));
            }
            setReloadPage(true);
        } catch (ex) {
            toast.error("Duyệt KPI không thành công");
        }
        dispatch(hideLoadingScreen());
    }

    const selectRow = (record: KPIDuyetResponse) => {
        if (record.trangThai == trangThaiKPI.trinhLanhDaoDonVi || (record.trangThai == trangThaiKPI.trinhLanhDaoPhuTrach && record.idDonViPhuTrach == null)) {
            const newSelectedRowKeys = [...selectedRowKeys];
            if (newSelectedRowKeys.indexOf(record.idKPICaNhan) >= 0) {
                newSelectedRowKeys.splice(newSelectedRowKeys.indexOf(record.idKPICaNhan), 1);
                const newSelectedRows = selectedRows.filter((item) => item.idKPICaNhan !== record.idKPICaNhan);
                setSelectedRows([...newSelectedRows]);
            } else {
                newSelectedRowKeys.push(record.idKPICaNhan);
                setSelectedRows([...selectedRows, record]);
            }
            setSelectedRowKeys(newSelectedRowKeys);
        }
    }

    const onSelectedRowKeysChange = (newSelectedRowKeys: React.Key[], newSelectedRows: KPIDuyetResponse[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
        setSelectedRows(newSelectedRows);
    };

    const layClassName = (value: any) => {
        let result = "btn-primary";
        if ((value.lanhDaoDonVi != null && value.trangThai == trangThaiKPI.pheDuyet)) {
            result = "btn-success";

        }
        return result;
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let idDV = +(params.get('idDonVi') || '');
        if (idDV > 0) {
            setIdDonVi(+idDV);
        }
        let thangNamParams = (params.get('thangNam') || '');
        var thangNamDayjs = dateCommon.convertThangNamToDayjs(thangNamParams);
        var dateStr = "";
        if (thangNamDayjs != null) {
            dateStr = thangNamDayjs?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
            setNgayThang(thangNamDayjs);
            setThangNam(dateStr);
        }
        if (reloadPage) {
            setData([]);
            setDanhSach({
                "data": [],
                "nhanViens": []
            });
            timkiem(idDV > 0 ? idDV : idDonVi, tuKhoa, dateStr != "" ? dateStr : thangNam);
            layThongTinKPIThang(thangNamDayjs != null ? thangNamParams : ngayThang?.format('MM/YYYY') || "");
            setSelectedRowKeys([]);
            setSelectedRows([]);
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(idDonVi, tuKhoa, thangNam);
        }
    };
    const traVeBtn = menu[Links.KPI.LanhDaoDonViDuyet] && (tongHopKPI != null && tongHopKPI?.trangThai == trangThaiKPITongHop.trinhGiamDoc);
    const duyetBtn = menu[Links.KPI.LanhDaoDonViDuyet] && tongHopKPI != null &&
        (tongHopKPI.trangThai == trangThaiKPITongHop.trinhGiamDoc || tongHopKPI.trangThai == trangThaiKPITongHop.pheDuyet)
        && data.some(record => record.trangThai == trangThaiKPI.trinhLanhDaoDonVi || (record.trangThai == trangThaiKPI.khoiTao && record.idNhanVien == user.idNhanVien));
    const duyetBtnModal = menu[Links.KPI.LanhDaoDonViDuyet] && tongHopKPI != null &&
        (tongHopKPI.trangThai == trangThaiKPITongHop.trinhGiamDoc || tongHopKPI.trangThai == trangThaiKPITongHop.pheDuyet)
        && openModalChiTiet?.data?.some(record => record.trangThai == trangThaiKPI.trinhLanhDaoDonVi || (record.trangThai == trangThaiKPI.khoiTao && record.idNhanVien == user.idNhanVien));
    return (<section>
        <ContentHeader title="Duyệt KPI" />
        <ModalTongHopLoiViPham
            show={openModalLoiViPham}
            thangNam={thangNam}
            onClose={() => setOpenModalLoiViPham(false)}
        />
        {activeTab != "3" ?
        <Row className="form-group" gutter={8}>
            <Col span={4}>
                <DatePicker
                    changeOnBlur={true}
                    allowClear={false}
                    value={ngayThang}
                    style={{ width: "100%" }}
                    placeholder="Tháng đánh giá"
                    picker="month"
                    format={thangNamFormat}
                    onChange={onChange} />
            </Col>
            <Col span="6">
                <ContainerDonViPhuTrach {...containerDepartmentProps} />
            </Col>
            {activeTab == "1" ? <Col span={5}>
                <Space>
                    <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => {
                        timkiem(idDonVi, tuKhoa, thangNam);
                        layThongTinKPIThang(ngayThang?.format('MM/YYYY') || "");
                    }}>
                        Tìm kiếm
                    </Button>
                    {user.maChucVu == maChucVu.giamDoc && <Button
                        className="hrm-btn hrm-btn-success"
                        title="Xem tổng hợp lỗi vi phạm"
                        onClick={() => {
                            setOpenModalLoiViPham(true);
                        }}>
                        Lỗi vi phạm
                    </Button>}
                </Space>
            </Col> : <>
                <Col span={5}>
                    <Input allowClear prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, mã nhân viên" onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Col span={5}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => {
                            timkiem(idDonVi, tuKhoa, thangNam);
                            layThongTinKPIThang(ngayThang?.format('MM/YYYY') || "");
                        }}>
                            Tìm kiếm
                        </Button>
                        {user.maChucVu == maChucVu.giamDoc && <Button
                            className="hrm-btn hrm-btn-success"
                            title="Xem tổng hợp lỗi vi phạm"
                            onClick={() => {
                                setOpenModalLoiViPham(true);
                            }}>
                            Lỗi vi phạm
                        </Button>}
                    </Space>
                </Col>
                <Col span={4}>
                        <Space className="float-right">
                            {
                                // button trả về của Giám đốc
                                menu[Links.KPI.LanhDaoDonViDuyet] && (tongHopKPI != null && tongHopKPI?.trangThai == trangThaiKPITongHop.trinhGiamDoc)
                                && user.maChucVu == maChucVu.giamDoc &&
                                <Button
                                    type="primary"
                                    icon={<CloseOutlined rev="" />}
                                    className="hrm-btn-delete float-right"
                                    onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Trả lại bảng tổng hợp KPI",
                                            content:
                                                <>Bạn có muốn <label>Trả lại</label> bảng tổng hợp KPI này không?</>,
                                            onSubmit: eventTraLaiTongHopKPI
                                        });
                                    }
                                    }
                                >
                                    Trả lại
                                </Button>
                            }
                            {
                                // button duyệt của Giám đốc
                                duyetBtn &&
                                <Button
                                    type="primary"
                                    icon={<CheckOutlined rev="" />}
                                    className="hrm-btn float-right"
                                    onClick={eventDuyetKPICaNhan}
                                >
                                    Duyệt
                                </Button>
                            }
                        </Space>
                </Col></>}
        </Row>
            : <Row className="form-group" gutter={8}>
                <Col span="6">
                    <ContainerDonViPhuTrach value={idDonViCV} onChange={(e) => { setIdDonViCV(e.id) }} />
                </Col>
                <Col span={6}>
                    <Input allowClear prefix={<SearchOutlined rev="" />} placeholder="Nhập tên để tìm kiếm" onChange={(e) => setTuKhoaCV(e.target.value)} />
                </Col>
            </Row>}
        <Tabs activeKey={activeTab}
            onChange={(key) => setActiveTab(key)}
            items={[
                {
                    key: '1',
                    label: 'Kết quả hoàn thành công việc',
                    children: <TabKetQuaHoanThanh
                        showYKienVanPhong
                        danhsach={danhsach}
                        tongHopKPI={tongHopKPI}
                        menu={menu}
                        user={user}
                        setOpenModalChiTiet={setOpenModalChiTiet}
                        eventDuyetKPICaNhan={eventDuyetToanDonVi}
                        duyetToanDonViBtn={duyetBtn}
                        traVeBtn={traVeBtn}
                        setConfirmModal={setConfirmModal}
                        eventTraLaiTongHopKPI={eventTraLaiTongHopKPI}
                    />
                },
                {
                    key: '2',
                    label: 'Duyệt KPI',
                    children:
                        <> {
                            tongHopKPI != null && (tongHopKPI?.trangThai == trangThaiKPITongHop.trinhGiamDoc || tongHopKPI?.trangThai == trangThaiKPITongHop.pheDuyet) &&

                            <div className="card" style={{padding: '12px 16px', marginBottom: '10px'}}><YKienVanPhong tongHopKPI={tongHopKPI} /></div>
                        }
                            <Row gutter={8}>
                                <Col span="24">
                                    <Space className="float-right" style={{ marginBottom: 8, padding: '0 8px', fontSize: '12px', fontStyle: "italic", fontFamily: '"Times New Roman", Times, serif' }}>
                                        <span style={{ fontWeight: 600 }}>Chú thích nút Xem:</span>
                                        <Space size={4}>
                                            <span className="hrm-btn hrm-btn-sm btn-primary" style={{ width: 16, height: 16, display: 'inline-block', borderRadius: 3 }} />
                                            <span>Chưa đánh giá</span>
                                        </Space>
                                        <Space size={4}>
                                            <span className="hrm-btn hrm-btn-sm btn-success" style={{ width: 16, height: 16, display: 'inline-block', borderRadius: 3 }} />
                                            <span>Đã đánh giá</span>
                                        </Space>
                                    </Space>
                                </Col>
                                <Col span="24">
                                    <div className="card card-primary">
                                        <Row>
                                            <Col span="24">
                                                <DuyetKPIGiamDocTable
                                                    data={data}
                                                    isLoadingTable={isLoadingTable}
                                                    tongHopKPI={tongHopKPI}
                                                    selectedRowKeys={selectedRowKeys}
                                                    onSelectedRowKeysChange={onSelectedRowKeysChange}
                                                    selectRow={selectRow}
                                                    setData={setData}
                                                    layClassName={layClassName}
                                                    titleTongSoLoi="Tổng số lỗi trong năm"
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row></>
                },
                {
                    key: '3',
                    label: "Quản lý công việc",
                    children: <QuanLyTieuDeKPI tuKhoa={tuKhoaCV} idDonVi={idDonViCV} />
                }
            ]} />

        <ModalTextForm
            show={confirmModal.isShowModal}
            title={confirmModal.title}
            handleClose={() => setConfirmModal({ isShowModal: false })}
            handleSave={() => {
                confirmModal.onSubmit();
                setConfirmModal({ isShowModal: false });
            }}
        >
            {confirmModal.content}
        </ModalTextForm>

        <ModalTextForm
            dialogClassName={"modal-80wh"}
            show={openModalChiTiet.isShowModal}
            title={openModalChiTiet.isDuyet ?
                <> Bạn có muốn <label>Duyệt</label> {selectedRows.length} bảng đánh giá KPI này không?</>:
                <>
                    Chi tiết kết quả đánh giá trong tháng
                    {openModalChiTiet.tenDonVi ? <span> - <strong>{openModalChiTiet.tenDonVi}</strong></span> : ''}
                </>
            }
            handleClose={() => setOpenModalChiTiet({ isShowModal: false, data: [] })}
            handleSave={() => {
                openModalChiTiet.onSubmit();
                setOpenModalChiTiet({ isShowModal: false });
            }}
            hideFooter={!openModalChiTiet.isDuyet }
        >
            <Row>
                <Col span="24">
                    {
                        duyetBtnModal && !openModalChiTiet.isDuyet && (
                            <Space className="float-right" style={{ marginBottom:"5px" }}> <Button
                                type="primary"
                                icon={<CheckOutlined rev="" />}
                                className="hrm-btn"
                                onClick={eventDuyetKPICaNhan}
                            >
                                Duyệt
                            </Button> </Space>
                        )
                    }</Col>
                <Col span="24">
                    <Space className="float-right" style={{ marginBottom: 8, padding: '0 8px', fontSize: '12px', fontStyle: "italic", fontFamily: '"Times New Roman", Times, serif' }}>
                        <span style={{ fontWeight: 600 }}>Chú thích nút Xem:</span>
                        <Space size={4}>
                            <span className="hrm-btn hrm-btn-sm btn-primary" style={{ width: 16, height: 16, display: 'inline-block', borderRadius: 3 }} />
                            <span>Chưa đánh giá</span>
                        </Space>
                        <Space size={4}>
                            <span className="hrm-btn hrm-btn-sm btn-success" style={{ width: 16, height: 16, display: 'inline-block', borderRadius: 3 }} />
                            <span>Đã đánh giá</span>
                        </Space>
                    </Space>
                </Col>
                <Col span="24">
                    <DuyetKPIGiamDocTable
                        data={openModalChiTiet?.data}
                        hideSelection={openModalChiTiet.isDuyet}
                        isLoadingTable={isLoadingTable}
                        tongHopKPI={tongHopKPI}
                        selectedRowKeys={selectedRowKeys}
                        onSelectedRowKeysChange={onSelectedRowKeysChange}
                        selectRow={selectRow}
                        setData={setData}
                        layClassName={layClassName}
                        titleTongSoLoi="Lỗi năm"
                        tongSoLoiWidth="74px"
                    />
                </Col>
            </Row>
        </ModalTextForm>
    </section>
    );
};

export default DuyetKPIGiamDoc;
